module.exports = __webpack_public_path__ + "img/zbrksl.88198307.png";